function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgVerified(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 16,
    viewBox: "0 0 17 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "check-verified-02",
    clipPath: "url(#clip0_629_1202)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Icon",
    d: "M12.8432 3.3325C12.9805 3.66452 13.244 3.92843 13.5758 4.06621L14.7393 4.54815C15.0713 4.68568 15.3351 4.94949 15.4726 5.28154C15.6101 5.61358 15.6101 5.98666 15.4726 6.3187L14.991 7.48136C14.8535 7.81355 14.8533 8.18701 14.9915 8.51904L15.4722 9.68136C15.5404 9.84582 15.5755 10.0221 15.5755 10.2001C15.5756 10.3782 15.5405 10.5545 15.4724 10.7189C15.4043 10.8834 15.3044 11.0328 15.1785 11.1587C15.0526 11.2846 14.9031 11.3844 14.7386 11.4525L13.576 11.9341C13.244 12.0714 12.9801 12.3349 12.8423 12.6667L12.3604 13.8302C12.2229 14.1622 11.9591 14.426 11.627 14.5636C11.295 14.7011 10.9219 14.7011 10.5899 14.5636L9.42729 14.082C9.09525 13.9448 8.72232 13.9451 8.39048 14.0828L7.22703 14.564C6.89518 14.7012 6.52244 14.7011 6.19068 14.5637C5.85892 14.4263 5.59527 14.1628 5.45764 13.8311L4.97558 12.6672C4.8383 12.3352 4.57479 12.0713 4.243 11.9335L3.07954 11.4516C2.74765 11.3141 2.48394 11.0505 2.34635 10.7186C2.20877 10.3868 2.20858 10.0138 2.34583 9.68186L2.82741 8.5192C2.9646 8.18714 2.96432 7.8142 2.82663 7.48235L2.34575 6.31802C2.27757 6.15356 2.24246 5.97728 2.24243 5.79925C2.2424 5.62122 2.27745 5.44493 2.34558 5.28045C2.41371 5.11597 2.51357 4.96653 2.63948 4.84066C2.76538 4.7148 2.91485 4.61498 3.07934 4.5469L4.24196 4.06531C4.57368 3.92814 4.83742 3.66496 4.9753 3.33353L5.45722 2.17004C5.59475 1.83799 5.85855 1.57419 6.19058 1.43665C6.52261 1.29911 6.89568 1.29911 7.22771 1.43665L8.39033 1.91824C8.72237 2.05544 9.0953 2.05516 9.42713 1.91746L10.5911 1.4374C10.9231 1.29994 11.2961 1.29996 11.628 1.43747C11.96 1.57498 12.2237 1.83872 12.3613 2.17067L12.8434 3.33452L12.8432 3.3325Z",
    fill: "#2C9AFF",
    stroke: "#2C9AFF",
    style: {
      fill: "#2C9AFF",
      fill: "color(display-p3 0.1708 0.6020 1.0000)",
      fillOpacity: 1,
      stroke: "#2C9AFF",
      stroke: "color(display-p3 0.1708 0.6020 1.0000)",
      strokeOpacity: 1
    },
    strokeWidth: 1.33333,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Icon_2",
    d: "M6.90909 8.00016L8.24242 9.3335L11.2424 6.3335",
    stroke: "white",
    style: {
      stroke: "white",
      strokeOpacity: 1
    },
    strokeWidth: 1.33333,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_629_1202"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white",
    style: {
      fill: "white",
      fillOpacity: 1
    },
    transform: "translate(0.909088)"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVerified);
export default __webpack_public_path__ + "static/media/verified.71c5bc2ca13bcaa7da0e42ab1544d68d.svg";
export { ForwardRef as ReactComponent };